import React from 'react';

import { Table, Button, Divider, DatePicker, Row, Col } from 'antd/lib';
import * as Icons from '@ant-design/icons';
const { RangePicker } = DatePicker;
import moment from 'moment';

class TablaOficios extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: this.props.certificaciones,
    };
  }

  descargar = () => {
    this.props.onDescargar();
  };

  render() {
    const columns = [
      {
        title: 'Nombre',
        dataIndex: 'nombre',
        key: 'nombre',
      },
      {
        title: 'Numero',
        dataIndex: 'numero',
        key: 'numero',
      },
      {
        title: 'Fecha',
        dataIndex: 'fechaCreacion',
        key: 'fechaCreacion',
        render: fecha => moment(fecha).format('DD/MM/YYYY'),
      },
      {
        title: 'Usuario',
        dataIndex: 'usuarioCreador',
        key: 'usuarioCreador',
        render: creador => (creador ? creador.apellido.toUpperCase() : '-'),
      },
      {
        title: 'Acciones',
        key: 'acciones',
        render: (text, record) => (
          <span>
            <Button
              size="small"
              // type="primary"
              icon={<Icons.PrinterOutlined />}
              onClick={() =>
                record.urlMinio
                  ? this.props.descargar(record)
                  : this.props.imprimir(record)
              }
            />
            <Divider type="vertical" />
            <Button
              onClick={() => this.props.mostrarModalMandarEmail(record._id)}
              size="small"
              icon={
                <Icons.MailOutlined
                  style={{
                    color: record.enviadoPorEmail ? '#27b504' : '#000000',
                  }}
                />
              }
            />
            <Divider type="vertical" />
            <Button
              size="small"
              onClick={() => this.props.mostrarModalVisorEmail(record._id)}
              icon={<Icons.SearchOutlined />}
            />
            <Divider type="vertical" />
            <Button
              size="small"
              type="primary"
              icon={<Icons.EditOutlined />}
              disabled={!record.modificable}
              onClick={() =>
                this.props.history.push(`/admin/oficios/${record._id}`)
              }
            />
            <Divider type="vertical" />
            <Button
              size="small"
              type="danger"
              icon={<Icons.DeleteOutlined />}
              onClick={() => this.props.onDelete(record._id)}
            />
          </span>
        ),
      },
    ];
    const { oficios } = this.props;

    const paginationOptions = {
      onChange: page => {
        this.props.cambiarPagina(page);
      },
      total: this.props.total,
      current: this.props.pagina,
      pageSize: this.props.cantidadPorPagina,
      pageSizeOptions: ['2', '5', '10', '20', '50'],
      showSizeChanger: true,
      showQuickJumper: true,
      onShowSizeChange: (current, pageSize) => {
        this.props.cambiarTamañoPagina(pageSize);
        this.props.cambiarPagina(1);
      },
    };

    return (
      <Table
        rowKey="_id"
        columns={columns}
        pagination={paginationOptions}
        dataSource={oficios}
        loading={this.props.loadingTabla}
        title={() => (
          <div>
            {' '}
            <h2 style={{ textAlign: 'center' }}> Documentos Independientes </h2>
            <div style={{ textAlign: 'center' }}>
              {' '}
              <Row>
                <Col span={6}>
                  Cantidad Total de Documentos: {this.props.total}
                </Col>
                <Col span={12}>
                  <RangePicker
                    onChange={this.props.onChange}
                    defaultValue={
                      this.props.fechaInicio && this.props.fechaFin
                        ? [
                            moment(this.props.fechaInicio),
                            moment(this.props.fechaFin),
                          ]
                        : [moment().subtract(7, 'd'), moment()]
                    }
                    format={'DD-MM-YYYY'}
                  />
                </Col>{' '}
              </Row>
            </div>{' '}
          </div>
        )}
        locale={{
          emptyText: 'Sin Documentos Independientes cargados.',
        }}
      />
    );
  }
}

export default TablaOficios;
